import { useState } from "react";
import "./../../assets/style/components/view-height.scss";
import Layout from "../../components/common/layout";
import BoxIcon from "../../assets/images/picture/box.png";
import SnakeIcon from "../../assets/images/picture/snake.png";
import GlobeIcon from "../../assets/images/picture/globe.png";
import { ReactComponent as CloseModalIcon } from "../../assets/images/icon/delete.svg";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import ViewHeightFull from "./../../components/common/viewHeightFull";
function Home() {
  const [newslettersModalShow, setNewslettersModalShow] = useState(false);
  return (
    <>
      <Layout withGrassFooter={true}>
        <ViewHeightFull>
          <section className="home">
            <h1>Welcome To AI Nature</h1>
            <div className="items">
              <div
                className="item deactivate__box"
                onClick={() => setNewslettersModalShow(true)}
              >
                <img src={BoxIcon} className="box" alt="www.Dariatech.com" />
                <h6>Snakebite first aid</h6>
                <div className="coming__soon">SOON</div>
              </div>
              <Link to="/imageIdentification">
                <div className="item">
                  <img
                    src={SnakeIcon}
                    className="snake"
                    alt="www.Dariatech.com"
                  />
                  <h6> Snake image identification</h6>
                  <div className="coming__soon">SOON</div>
                </div>
              </Link>
              <div
                className="item deactivate__box"
                onClick={() => setNewslettersModalShow(true)}
              >
                <img
                  src={GlobeIcon}
                  className="globe"
                  alt="www.Dariatech.com"
                />
                <h6>Snakebite Risk estimation</h6>
                <div className="coming__soon">SOON</div>
              </div>
            </div>
          </section>
        </ViewHeightFull>
      </Layout>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={newslettersModalShow}
        onHide={() => setNewslettersModalShow(false)}
      >
        <div className="home__modal">
          <div className="modal__header">
            <h6>Sorry, This feature in under development</h6>
            <div
              className="close__modal"
              onClick={() => setNewslettersModalShow(false)}
            >
              <CloseModalIcon />
            </div>
          </div>
          <div className="modal__content">
            <h6>Enter your email to notify you when this feature is actived</h6>
            <input type="text" placeholder="Emial Address" />
          </div>
          <div className="modal__footer">
            <button type="submit" className="submit">
              Submit
            </button>
            <button
              className="return"
              onClick={() => setNewslettersModalShow(false)}
            >
              close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Home;
